(function () {
  'use strict';
  if (window.SBAnalytics) return;
  var config = document.querySelector('[data-sb-analytics]');
  var destination = config && config.getAttribute('data-measurement-id');
  var context = config && config.getAttribute('data-theme-context');
  var debug = context === 'unpublished';
  var seen = new WeakSet();
  var nativeKey = 'sb_native_add';
  var pendingEvents = [];
  var disclosurePresses = new WeakSet();
  function contentSection(element) {
    if (!element || !element.closest) return 'other';
    var sections = ['faqs', 'description', 'specifications', 'shipping', 'warranty', 'reviews', 'superclub'];
    for (var i = 0; i < sections.length; i++) {
      if (element.closest('.tab-content--body--' + sections[i])) return sections[i];
    }
    if (element.closest('.pdp-faq, .rivo-faq-item, .shopify-section-faqs')) return 'faqs';
    if (element.closest('.quick-specs-block, .specification-sheet')) return 'specifications';
    if (element.closest('.main-product-gallery')) return 'product_media';
    if (element.closest('header, [role="banner"]')) return 'header';
    if (element.closest('footer, [role="contentinfo"]')) return 'footer';
    return pageType() === 'product' ? 'product_main' : pageType();
  }
  function contentEvent(name, element, params) {
    var data = { interaction_surface: pageType() === 'product' ? 'product_content' : surface(element),
      content_section: contentSection(element) };
    if (pageType() === 'product') data.product_id = config.getAttribute('data-product-id') || '';
    emit(name, Object.assign(data, params || {}));
  }
  function trackLink(anchor, event) {
    var raw = anchor.getAttribute('href');
    if (!raw) return;
    var next = new URL(raw, location.href);
    var type = '', destination = '';
    if (next.protocol === 'tel:' || next.protocol === 'mailto:') {
      type = next.protocol === 'tel:' ? 'phone' : 'email'; destination = type;
    } else if (/^https?:$/.test(next.protocol)) {
      var own = next.origin === location.origin || /^(www\.)?superbreakers\.com$/.test(next.hostname);
      type = anchor.hasAttribute('download') || /\.(pdf|zip|xlsx?|docx?)(?:$)/i.test(next.pathname) ? 'download_link' :
        next.origin === location.origin && next.pathname === location.pathname && next.hash ? 'anchor' : own ? 'internal' : 'external';
      // Never send query strings, arbitrary fragments, contact addresses, or private account paths.
      destination = own ? (/^\/(products|collections|pages)\/[a-z0-9\/-]+$/i.test(next.pathname) || next.pathname === '/' ? next.pathname :
        /^\/cart\/?$/.test(next.pathname) ? '/cart' : /^\/account(?:\/|$)/.test(next.pathname) ? '/account' : 'other_internal') : next.hostname;
    } else return;
    contentEvent('sb_link_click', anchor, { interaction_action: type, link_destination: destination,
      link_target: anchor.target === '_blank' || event.ctrlKey || event.metaKey || event.button === 1 ? 'new_context' : 'same_context' });
  }
  function journey(update) {
    try {
      if (!allowed()) return {};
      var record = JSON.parse(sessionStorage.getItem('sb_journey') || 'null');
      if (!record || Date.now() - record.at > 1800000) record = { entry_page_type: pageType() };
      Object.keys(update || {}).forEach(function (key) { record[key] = update[key]; });
      record.at = Date.now();
      sessionStorage.setItem('sb_journey', JSON.stringify(record));
      return { entry_page_type: record.entry_page_type,
        navigation_surface: record.navigation_surface || 'direct',
        filter_surface: record.filter_surface || 'none' };
    } catch (_) { return {}; }
  }
  function attribution(productId, source) {
    try {
      if (!allowed() || !productId) return '';
      var entries = JSON.parse(sessionStorage.getItem('sb_product_sources') || '{}');
      Object.keys(entries).forEach(function (id) { if (Date.now() - entries[id].at > 1800000) delete entries[id]; });
      if (source) entries[String(productId)] = { source: source, at: Date.now() };
      sessionStorage.setItem('sb_product_sources', JSON.stringify(entries));
      return entries[String(productId)] && entries[String(productId)].source || 'direct';
    } catch (_) { return 'direct'; }
  }
  function allowed() {
    try {
      return !document.prerendering && !(window.theme && window.theme.editor) &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true;
    } catch (_) { return false; }
  }
  function pageType() {
    var path = location.pathname;
    if (path === '/') return 'homepage';
    if (/\/a\/search\/?$|\/search\/?$/.test(path)) return 'search_results';
    if (path.indexOf('/products/') !== -1) return 'product';
    if (/\/cart\/?$/.test(path)) return 'cart';
    if (document.querySelector('hub-breaker-browse, .sb-landing-catalog')) return 'category_hub';
    if (path.indexOf('/collections/') !== -1) return 'collection';
    if (/\/account(?:\/|$)/.test(path)) return 'account';
    if (/\/pages\/get-a-quote\/?$/.test(path)) return 'quote';
    if (/\/pages\/contact(?:-us)?\/?$/.test(path)) return 'contact';
    if (/\/pages\/(?:superclub|super-club|rewards)\/?$/.test(path)) return 'superclub';
    if (/\/pages\/super-gear-merchandise\/?$/.test(path)) return 'merchandise';
    return 'other';
  }
  function emit(name, params, arrived) {
    try {
      if (!destination || document.prerendering || (window.theme && window.theme.editor)) return;
      if (!window.Shopify || !window.Shopify.customerPrivacy) {
        if (pendingEvents.length < 30) pendingEvents.push({ name: name, params: params, arrived: arrived });
        return;
      }
      if (!allowed() || typeof window.gtag !== 'function') return;
      var journeyUpdate = {};
      if (name === 'sb_filter_apply') journeyUpdate.filter_surface = params.interaction_surface;
      if (name === 'sb_navigation_arrival') journeyUpdate.navigation_surface = params.interaction_surface;
      var journeyData = journey(journeyUpdate);
      if (name === 'sb_product_select' && !arrived && params && params.product_id) {
        attribution(params.product_id, params.interaction_surface);
        try {
          sessionStorage.setItem('sb_pending_selection', JSON.stringify({ at: Date.now(),
            payload: Object.assign({}, params, { source_page_type: pageType() }) }));
          return;
        } catch (_) {}
      }
      var data = { send_to: destination, page_type: pageType(), theme_context: context,
        transport_type: 'beacon', page_location: location.origin + location.pathname, page_title: pageType(), page_referrer: '' };
      Object.assign(data, journeyData);
      Object.keys(params || {}).forEach(function (key) {
        var value = params[key];
        if (typeof value === 'number' && Number.isFinite(value)) data[key] = value;
        else if (typeof value === 'string') data[key] = value.slice(0, 100);
      });
      if (data.product_id) {
        data.item_id = data.product_id;
        data.discovery_surface = attribution(data.product_id, name === 'sb_product_select' ? data.interaction_surface : null);
      }
      if (debug) data.debug_mode = true;
      window.gtag('event', name, data);
      if (debug) {
        var log = document.getElementById('sb-analytics-diagnostics');
        if (!log) {
          log = document.createElement('script'); log.type = 'application/json';
          log.id = 'sb-analytics-diagnostics'; log.textContent = '[]';
          document.documentElement.appendChild(log);
        }
        var records = JSON.parse(log.textContent);
        records.push({ event: name, parameters: data });
        log.textContent = JSON.stringify(records.slice(-30));
      }
    } catch (_) {}
  }
  function surface(element) {
    if (!element || !element.closest) return 'unknown';
    var marked = element.closest('[data-sb-analytics-surface]');
    if (marked) return marked.getAttribute('data-sb-analytics-surface');
    var recommendation = element.closest('[data-cross-sell-source]');
    if (recommendation) return 'product_' + recommendation.getAttribute('data-cross-sell-source');
    if (element.closest('cart-cross-sells')) return 'cart_recommendations';
    if (element.closest('[data-facet-guide]')) return 'guided_filters';
    if (element.closest('.slider-filter')) return 'top_filter_strip';
    if (element.closest('.sidebar-section, [id^="FilterDrawer"]')) {
      return window.matchMedia('(max-width: 991px)').matches ? 'mobile_filter_drawer' : 'filter_sidebar';
    }
    if (element.closest('.collection-active-filters, .filter-active')) return 'active_filter_chips';
    if (element.closest('.sb-home-catalog')) return pageType() === 'homepage' ? 'homepage_categories' : 'category_hub';
    if (element.closest('.homepage-brand-band')) return 'homepage_brands';
    if (element.closest('.sb-home-promos, .sb-home-promotions')) return 'homepage_promotions';
    if (element.closest('breaker-progressive-finder')) return 'breaker_finder';
    if (element.closest('hub-breaker-browse')) return 'category_hub';
    if (element.closest('brand-mega-component, .brand-mega')) return 'desktop_megamenu';
    if (element.closest('[data-nav-brand], .mobile-menu, mobile-navigation')) return 'mobile_menu';
    if (element.closest('header, [role="banner"]')) return 'header_navigation';
    if (element.closest('footer, [role="contentinfo"]')) return 'footer_navigation';
    return pageType() === 'product' ? 'product_main' : pageType();
  }
  function count(root) {
    var el = (root || document).querySelector('[data-search-results-total], .collection-count, .search-count, .jsFilterResultCount');
    if (!el) return -1;
    var raw = el.getAttribute('data-search-results-total') || el.textContent;
    var match = raw.match(/\d[\d,]*/);
    return match ? Number(match[0].replace(/,/g, '')) : -1;
  }
  function filterIntent(element) {
    try {
      var block = element.closest('[data-sfs-group], .filter-block');
      return { interaction_surface: surface(element),
        filter_group: element.getAttribute('data-sfs-group') || (block && block.getAttribute('data-sfs-group')) || 'unknown',
        filter_action: element.matches('[data-sfs-clear-filters], .jsFilterReset, .btn-filter-reset') ? 'clear' :
          element.matches('[data-sfs-remove-filter], .jsFilterRemove') ? 'remove' : 'change' };
    } catch (_) { return null; }
  }
  function filterCommit(intent, root) {
    if (!intent) return;
    emit('sb_filter_apply', Object.assign({}, intent, { result_count: count(root) }));
  }
  function addResult(element, item, quantity, success) {
    var payload = {
      interaction_surface: surface(element), product_id: String(item && item.product_id || ''),
      variant_id: String(item && (item.variant_id || item.id) || ''), quantity: Number(quantity) || 1
    };
    if (success) {
      try {
        if (window.SBJourney && typeof window.SBJourney.addOk === 'function') {
          var okSource = '';
          try {
            if (element && element.closest) {
              var rec = element.closest('[data-cross-sell-source]');
              if (rec) {
                var cross = rec.getAttribute('data-cross-sell-source') || '';
                if (cross === 'similar-items' || cross === 'similar') okSource = 'similar_items';
                else if (cross === 'purchase' || cross === 'fbt') okSource = 'fbt';
                else if (cross) okSource = 'cross_sell';
              } else if (element.closest('cart-cross-sells, [data-cart-cross-sells]')) {
                okSource = 'purchase_addon';
              }
            }
          } catch (eSrc) {}
          window.SBJourney.addOk({
            product_id: payload.product_id,
            variant_id: payload.variant_id,
            qty: payload.quantity,
            sku: String(item && item.sku || ''),
            source: okSource
          });
        }
      } catch (_) {}
    }
    if (success && element && element.redirectsToCart && allowed()) {
      try {
        sessionStorage.setItem('sb_confirmed_add', JSON.stringify({ at: Date.now(), payload: payload }));
        return;
      } catch (_) {}
    }
    emit(success ? 'sb_add_success' : 'sb_add_error', payload);
  }
  window.SBAnalytics = { emit: emit, surface: surface, filterIntent: filterIntent,
    filterCommit: filterCommit, addResult: addResult, allowed: allowed };
  function flush() {
    if (!window.Shopify || !window.Shopify.customerPrivacy) return;
    var queue = pendingEvents; pendingEvents = [];
    queue.forEach(function (event) { emit(event.name, event.params, event.arrived); });
  }
  document.addEventListener('visitorConsentCollected', flush);
  document.addEventListener('visitorConsentCollected', function () {
    if (allowed()) return;
    try {
      ['sb_journey', 'sb_navigation', 'sb_product_sources', 'sb_pending_selection', 'sb_confirmed_add', nativeKey]
        .forEach(function (key) { sessionStorage.removeItem(key); });
    } catch (_) {}
  });
  try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], flush); } catch (_) {}
  setTimeout(function () { pendingEvents = []; }, 3000);

  document.addEventListener('submit', function (event) {
    try {
      var form = event.target;
      if (!form.matches('form') || !form.checkValidity()) return;
      var action = new URL(form.action, location.origin).pathname;
      if (/\/cart\/?$/.test(action) && event.submitter && event.submitter.name === 'checkout') {
        return;
      }
      if (/\/a\/search\/?$|\/search\/?$/.test(action)) {
        emit('sb_search_submit', { interaction_surface: form.closest('.sb-home-hero') ? 'homepage_search' : 'header_search' });
        return;
      }
      if (!/\/cart\/add(?:\.js)?$/.test(action)) return;
      var fields = new FormData(form);
      var payload = { interaction_surface: surface(form), variant_id: String(fields.get('id') || ''),
        quantity: Math.max(1, Number(fields.get('quantity')) || 1) };
      var productCard = form.closest('[data-product-id]');
      payload.product_id = productCard ? productCard.getAttribute('data-product-id') : config.getAttribute('data-product-id') || '';
      emit('sb_add_attempt', payload);
      try {
        var trackOk = false;
        try {
          if (typeof window.sbTrackingAllowed === 'function') trackOk = window.sbTrackingAllowed() === true;
          else {
            trackOk = allowed();
            var privacy = window.Shopify && window.Shopify.customerPrivacy;
            if (privacy && typeof privacy.saleOfDataAllowed === 'function' && privacy.saleOfDataAllowed() === false) trackOk = false;
          }
        } catch (eGate) { trackOk = false; }
        if (trackOk) {
          var sid = sessionStorage.getItem('sfs_sid');
          if (sid && /^[A-Za-z0-9_-]{8,64}$/.test(sid)) {
            if (!form.querySelector('[name="properties[_sfs_sid]"]')) {
              var sidInput = document.createElement('input');
              sidInput.type = 'hidden';
              sidInput.name = 'properties[_sfs_sid]';
              sidInput.value = sid;
              form.appendChild(sidInput);
            }
            if (window.theme && window.theme.searchBeacon &&
                typeof window.theme.searchBeacon.send === 'function' &&
                typeof window.theme.searchBeacon.buildPayload === 'function') {
              var lastQ = sessionStorage.getItem('sfs_last_q') || '';
              window.theme.searchBeacon.send(window.theme.searchBeacon.buildPayload(
                lastQ, 'atc', -1, pageType() || 'product', null, payload.product_id));
            }
          }
        }
      } catch (_) {}
      if (!form.matches('[data-pdp-cross-sell-add]') || !allowed()) return;
      var existing = form.querySelector('[name="return_to"]');
      if (existing) return;
      var token = Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem(nativeKey, JSON.stringify({ token: token, payload: payload, at: Date.now() }));
      var input = document.createElement('input'); input.type = 'hidden'; input.name = 'return_to';
      input.value = (window.Shopify.routes.root || '/') + 'cart?sb_add_token=' + token;
      form.appendChild(input);
    } catch (_) {}
  }, true);

  try {
    if (pageType() === 'product') {
      var selected = JSON.parse(sessionStorage.getItem('sb_pending_selection') || 'null');
      sessionStorage.removeItem('sb_pending_selection');
      if (selected && Date.now() - selected.at < 120000 &&
          String(selected.payload.product_id) === config.getAttribute('data-product-id')) {
        emit('sb_product_select', selected.payload, true);
      }
    }
    if (pageType() === 'cart') {
      var confirmed = JSON.parse(sessionStorage.getItem('sb_confirmed_add') || 'null');
      sessionStorage.removeItem('sb_confirmed_add');
      if (confirmed && Date.now() - confirmed.at < 120000) emit('sb_add_success', confirmed.payload);
    }
    var url = new URL(location.href), token = url.searchParams.get('sb_add_token');
    if (token && pageType() === 'cart') {
      var pending = JSON.parse(sessionStorage.getItem(nativeKey) || 'null');
      sessionStorage.removeItem(nativeKey);
      url.searchParams.delete('sb_add_token'); history.replaceState(history.state, '', url.pathname + url.search + url.hash);
      if (pending && pending.token === token && Date.now() - pending.at < 120000) {
        emit('sb_add_success', pending.payload);
      }
    }
  } catch (_) {}

  document.addEventListener('click', function (event) {
    try {
      if (event.button > 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
      var target = event.target;
      var checkout = target.closest('button[name="checkout"]');
      // Count a shopper press once; queued cart updates can replay form submission.
      if (checkout && event.isTrusted !== false && (event.detail || document.activeElement === checkout)) {
        emit('sb_checkout_click', { interaction_surface: checkout.closest('[data-cart-sticky-bar]') ? 'cart_sticky_checkout' : 'cart_primary_checkout' });
      }
      var anchor = target.closest('a[href]');
      if (anchor && !anchor.closest('[data-product-id], .predictive__search-result, cart-cross-sells')) {
        var next = new URL(anchor.href, location.origin);
        if (next.origin === location.origin && next.pathname !== location.pathname &&
            /^\/(?:collections|products|pages|account|cart)(?:\/|$)/.test(next.pathname) &&
            (!anchor.target || anchor.target === '_self') && !anchor.hasAttribute('download') && allowed()) {
          journey();
          sessionStorage.setItem('sb_navigation', JSON.stringify({ at: Date.now(), path: next.pathname,
            payload: { interaction_surface: surface(anchor), source_page_type: pageType(), destination_path: next.pathname } }));
        }
      }
      var control = target.closest('.filter-btn .btn-filter, .jsFilterDrawerClose, .facet-guide__skip, .facet-guide__more');
      if (control) emit('sb_filter_control', { interaction_surface: surface(control),
        interaction_action: control.matches('.jsFilterDrawerClose') ? 'view_results' :
          control.matches('.facet-guide__skip') ? 'skip' : control.matches('.facet-guide__more') ? 'show_more' : 'open' });
      var card = target.closest('[data-product-id]');
      if (!card || target.closest('button,input,select,textarea,form')) return;
      var selection = window.getSelection && window.getSelection();
      if (selection && selection.toString().trim() && selection.anchorNode && card.contains(selection.anchorNode)) return;
      if (card.closest('cart-cross-sells, .predictive__search-result')) return;
      if (!target.closest('a') && !card.matches('.product-card')) return;
      emit('sb_product_select', { interaction_surface: surface(card), product_id: card.getAttribute('data-product-id') || '' });
    } catch (_) {}
  }, true);
  function contentClick(event) {
    try {
      if (event.isTrusted === false || event.button > 1) return;
      var target = event.target;
      var anchor = target.closest('a[href]');
      if (anchor) trackLink(anchor, event);
      if (event.type === 'auxclick') return;
      var summary = target.closest('summary');
      if (summary && allowed()) disclosurePresses.add(summary.closest('details'));
      if (pageType() !== 'product') return;
      var sectionLink = target.closest('.js-scroll-to');
      if (sectionLink) {
        var component = sectionLink.closest('product-description-component');
        if (event.detail && component && Date.now() < (component.suppressTabClickUntil || 0)) return;
        var selector = sectionLink.getAttribute('data-scroll');
        var panel = selector && document.querySelector(selector);
        contentEvent('sb_pdp_interaction', panel || sectionLink, { interaction_action: 'section_navigate' });
        return;
      }
      var control = target.closest('.main-product-gallery button, .thumbnail-gallery .media-item, [data-stock-help], .sb-warranty-note, .pdp-superpoints-tip, .scroll_point, #BIS_trigger');
      if (control) contentEvent('sb_pdp_interaction', control, { interaction_action:
        control.matches('#BIS_trigger') ? 'stock_notification_click' : control.matches('[data-stock-help]') ? 'stock_help_click' :
        control.matches('.sb-warranty-note') ? 'warranty_help_click' : control.matches('.pdp-superpoints-tip, .scroll_point') ? 'rewards_help_click' : 'media_control_click' });
    } catch (_) {}
  }
  document.addEventListener('click', contentClick, true);
  document.addEventListener('auxclick', function (event) { if (event.button === 1) contentClick(event); }, true);
  document.addEventListener('toggle', function (event) {
    try {
      var details = event.target;
      if (!details.matches('details') || !disclosurePresses.has(details)) return;
      disclosurePresses.delete(details);
      var faq = details.matches('.pdp-faq__item, .rivo-faq-item') || !!details.closest('.shopify-section-faqs');
      var index = Array.prototype.indexOf.call(document.querySelectorAll('details'), details) + 1;
      contentEvent(faq ? 'sb_faq_toggle' : 'sb_disclosure_toggle', details, {
        interaction_action: details.open ? 'open' : 'close', content_id: details.id && /^[a-z0-9_-]{1,100}$/i.test(details.id) ? details.id : 'disclosure_' + index
      });
    } catch (_) {}
  }, true);
  document.addEventListener('change', function (event) {
    try {
      if (pageType() !== 'product') return;
      var target = event.target;
      if (target.matches('.js-variant-change')) contentEvent('sb_pdp_interaction', target, { interaction_action: 'option_change' });
      else if (target.matches('input[name="quantity"]') && target.closest('product-cart-form')) {
        contentEvent('sb_pdp_interaction', target, { interaction_action: 'quantity_change' });
      }
    } catch (_) {}
  }, true);
  ['add', 'add_error', 'product_click', 'choose_options'].forEach(function (action) {
    document.addEventListener('cart_cross_sell_' + action, function (event) {
      var detail = event.detail || {};
      emit(action === 'add' ? 'sb_add_success' : action === 'add_error' ? 'sb_add_error' : 'sb_product_select', {
        interaction_surface: 'cart_recommendations', interaction_action: action,
        product_id: String(detail.productId || ''), variant_id: String(detail.variantId || ''), quantity: Number(detail.quantity) || 1
      });
    });
  });
  function observeRecommendations() {
    if (!window.IntersectionObserver) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.01 || !allowed()) return;
        if (!seen.has(entry.target)) {
          seen.add(entry.target);
          emit('sb_recommendation_view', { interaction_surface: surface(entry.target) });
        }
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.01 });
    document.querySelectorAll('cart-cross-sells, [data-cross-sell-source]').forEach(function (el) { observer.observe(el); });
  }
  observeRecommendations();
  document.addEventListener('visitorConsentCollected', observeRecommendations);
  try {
    var navigation = JSON.parse(sessionStorage.getItem('sb_navigation') || 'null');
    sessionStorage.removeItem('sb_navigation');
    if (navigation && navigation.path === location.pathname && Date.now() - navigation.at < 120000) {
      emit('sb_navigation_arrival', navigation.payload);
    }
  } catch (_) {}
  emit('sb_page_view', { interaction_surface: pageType() });
  if (pageType() === 'product') emit('sb_product_view', { interaction_surface: 'product_main', product_id: config.getAttribute('data-product-id') || '' });
  if (pageType() === 'search_results') emit('sb_search_results_view', { interaction_surface: 'search_results', result_count: count(document) });
})();
